<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="form-group">
          <div class="row">
            <div class="col">
              {{$store.translate('procedure_advanced_description')}}
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-1">
              <input-checkbox id="enableDescriptionTmp" @input="setEnableDescription" v-bind:checked="procedure.EnableDescription == true"></input-checkbox>
            </div>
            <div class="col-11">
              {{$t('enable_description')}}
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <input-checkbox id="enableStatus" @input="setEnableStatus" v-bind:checked="procedure.EnableStatus == true"></input-checkbox>
            </div>
            <div class="col-11">
              {{$t('enable_status')}}
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <input-checkbox id="enablePriority" @input="setEnablePriority" v-bind:checked="procedure.EnablePriority == true"></input-checkbox>
            </div>
            <div class="col-11">
              {{$t('enable_priority')}}
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <input-checkbox id="enableTimespent" @input="setEnableTimespent" v-bind:checked="procedure.EnableTimespent == true"></input-checkbox>
            </div>
            <div class="col-11">
              {{$t('enable_time_spent')}}
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <input-checkbox id="enablePrivateChat" @input="setEnablePrivateChat" v-bind:checked="procedure.Settings != null && procedure.Settings.Property != null && procedure.Settings.Property.EnablePrivateChat == 'True'"></input-checkbox>
            </div>
            <div class="col-11">
              {{$t('enable_private_chat')}}
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <input-checkbox id="enableScheduleTask" @input="setScheduleTask" v-bind:checked="procedure.IsScheduleTask  == true"></input-checkbox>
            </div>
            <div class="col-11">
              {{$t('enable_schedule_task')}}
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <input-checkbox id="enablePrivateProcedure" @input="setEnablePrivateProcedure" v-bind:checked="procedure.Private  == true"></input-checkbox>
            </div>
            <div class="col-11">
              {{$store.translate('enable_private_procedure')}}
            </div>
          </div>
          <div class="row" v-show="isSuperAdmin">
            <div class="col-1">
              <input-checkbox id="chk_global_setting" @input="setIsGlobal" v-bind:checked="procedure.IsGlobal == true"></input-checkbox>
            </div>
            <div class="col-11">
              Global
              {{$t('publish_procedure_globally')}}
            </div>
          </div>

          <div class="row mt-3" v-show="isSuperAdmin">
            <div class="col-lg-12 custom-form-label">
              {{ $store.translate('Email')}}
            </div>
          </div>
          <div class="form-group row mt-1" v-show="isSuperAdmin">
            <div class="col-lg-12">
              <input required @change="onChangeUsername" v-model="procedure.Username" type="text" id="txtprocusername" v-bind:placeholder="$store.translate('email')" maxlength="200" name="procusername" class="form-control" />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import InputCheckbox from "../form-components/input-checkbox.vue";
  import InputText from "../form-components/input-text.vue";

  var isSuperAdmin = false;

  export default {
    name: "procedure-advanced-settings",
    components: {
      InputCheckbox,
      InputText
    },
    props: {
      
    },
    data() {
      return {
        selected: 0,
        isSuperAdmin: false,
      };
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        
      }
    },
    methods: {
      onChangeUsername() {
        this.doSave();
      },
      setIsGlobal(val) {
        this.procedure.IsGlobal = val;
        this.doSave();
      },
      setEnableTimespent(val) {
        this.procedure.EnableTimespent = val;
        this.doSave();
      },
      setEnableMaterial(val) {
        this.procedure.EnableMaterial = val;
        this.doSave();
      },
      setEnableDescription(val) {
        this.procedure.EnableDescription = val;
        this.doSave();
      },
      setEnableStatus(val) {
        this.procedure.EnableStatus = val;
        this.doSave();
      },
      setEnablePriority(val) {
        this.procedure.EnablePriority = val;
        this.doSave();
      },
      setEnablePrivateChat(val) {
        if (this.procedure.Settings == null)
          this.procedure.Settings = this.initSettings();
        this.procedure.Settings.Property.EnablePrivateChat = val;
        this.doSave();
      },
      setEnablePrivateProcedure(val) {
        this.procedure.Private = val;
        this.doSave();
      },
      setScheduleTask(val) {
        this.procedure.IsScheduleTask = val;
        this.doSave();
      },
      initSettings() {
        return { "Data": null, "Items": [], "Property": {}, "Translations": [] };
      },
      open() {
        
      },
      doSave() {
        this.$store.commit('saveprocedure', this.procedure);
      },
      handleRefresh(val) {
        
      },
      
      getId() {
        return this._uid;
      },
      
    },
    mounted() {
      
    },
    
    watch: {
      
    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/procedure/procedure-advanced-settings.vue